import { Container } from "./styles";
import { LabelButton } from "views/components/LabelButton";
import { Spacer } from "views/components/common/Spacer";
import { Typography } from "antd";
import { dateToString } from "lib/date";
import { useGlobal } from "reactn";
import { useTranslation } from "react-i18next";
import React from "react";
import moment from "moment-timezone";

const { Title } = Typography;

export const ReservationConfirmationCard = ({
	officeName,
	lineName,
	selectedDate,
	onClick,
	attentionType,
	desktop,
	officeDirection,
}) => {
	const time =
		selectedDate &&
		selectedDate.from &&
		moment(selectedDate.from).format("H:mm [hrs]");
	const [language] = useGlobal("language");
	const date = dateToString(selectedDate.from, language.selected);
	const { t } = useTranslation("booking");

	return (
		<>
			<Container desktop={desktop}>
				<Title level={5}>{officeName}</Title>
				<div className={"line-name"}>{lineName}</div>

				<Spacer rows={0.6} />
				<LabelButton
					desktop={desktop}
					onClick={onClick}
					type={"date"}
					label={date}
				/>
				<Spacer rows={0.6} />
				<LabelButton
					desktop={desktop}
					onClick={onClick}
					type={"time"}
					label={time}
				/>
				<Spacer rows={0.6} />
				{officeDirection && (
					<>
						<LabelButton
							desktop={desktop}
							onClick={onClick}
							type={"address"}
							label={officeDirection}
						/>
						<Spacer rows={0.6} />
					</>
				)}
				<div className={"attention-details-message"}>
					{attentionType === "Videollamada"
						? t("lastStepMessageConfirmOne")
						: t("lastStepMessageConfirmTwo")}
				</div>
			</Container>
		</>
	);
};
